// Main entry point for Clinical Scheduling Dashboard V3
// Production-ready React application with TypeScript

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { GoogleOAuthProvider } from '@react-oauth/google'

// Application components
import { Suspense, lazy } from 'react'
// BUILD-TIME switch (decision DEP): Vite replaces import.meta.env.VITE_APP_MODE with a
// literal, so the branch not taken, and the module it imports, is dropped from the bundle.
const Root = import.meta.env.VITE_APP_MODE === 'pq'
  ? lazy(() => import('./PqApp'))
  : lazy(() => import('./App'));
import ErrorBoundary from '@/components/UI/ErrorBoundary'

// Auth (login gate — UI only)
import { GoogleAuthProvider } from '@/auth/GoogleAuthContext'
import LoginGate from '@/auth/LoginGate'

// Configuration and validation
import { validateConfig, createLogger, appConfig } from '@/utils/config'
import { installGoogleApiAuth } from '@/auth/googleApiAuth'

// Styles
import './index.css'

// =============================================================================
// Configuration Validation
// =============================================================================
const logger = createLogger('Main');

// Forward the operator's Google ID token (Authorization: Bearer) to backend API
// calls, with silent refresh. Must be installed before any component fires a request.
installGoogleApiAuth();

// Validate configuration on startup
if (!validateConfig()) {
  logger.error('Configuration validation failed');
  // In production, show user-friendly error instead of crashing
}

logger.info('Clinical Scheduling Dashboard V3 starting...');
logger.info('Environment:', import.meta.env.VITE_ENVIRONMENT);
logger.info('CRIO API Endpoint:', import.meta.env.VITE_CRIO_API_ENDPOINT);

// =============================================================================
// Application Rendering
// =============================================================================
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={appConfig.googleClientId}>
        <GoogleAuthProvider allowedDomain={appConfig.allowedGoogleDomain}>
          <LoginGate>
            <BrowserRouter>
              <Suspense fallback={null}><Root /></Suspense>
              <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#333',
              color: '#fff',
            },
            success: {
              iconTheme: {
                primary: '#28a745',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#dc3545',
                secondary: '#fff',
              },
            },
          }}
              />
            </BrowserRouter>
          </LoginGate>
        </GoogleAuthProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);